<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-transparent md-absolute "
    :class="extraNavClasses"
    :color-on-scroll="colorOnScroll"
    :style="headerImage"
  >
    <!-- <NavBarBank v-if="getToken().bank_id" :object-data="objectData" /> -->
    <NavBarMobile
      :key="$store.getters.isReRenderComponent"
      :object-data="objectData"
    />
    <div
      class="lang-pc md-toolbar-row md-collapse-lateral"
      style="height: 60px"
    >
      <div class="md-toolbar-section-start lang-pc">
        <RouterLink to="/wap">
          <img :src="images.LogoWBooking" alt="" :style="imageZise.pc" />
        </RouterLink>
      </div>
      <div class="md-toolbar-section-end">
        <md-button class="md-just-icon md-simple md-toolbar-toggle">
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <div style="display: flex">
              <md-list class="cursor-pointer">
                <md-list-item @click="handleHistory" href="#">
                  <p class="p-vid">
                    {{ $t("order") }}
                  </p>
                </md-list-item>
                <md-list-item @click="routePush('/san-noi-bat')" href="#">
                  <p class="p-vid">
                    {{ $t("wap.text136") }}
                  </p>
                </md-list-item>
                <md-list-item @click="routePush('/tin-tuc')" href="#">
                  <p class="p-vid">
                    {{ $t("wap.text148") }}
                  </p>
                </md-list-item>
                <md-list-item @click="routePush('/bang-gia')" href="#">
                  <p class="p-vid">
                    {{ $t("wap.text134") }}
                  </p>
                </md-list-item>
                <md-list-item class="lang-pc">
                  <el-dropdown trigger="click" @command="handleCommandPolicy">
                    <span class="el-dropdown-link">
                      <span class="text-lang c-black-text fw-600">
                        {{ $t("policy") }}</span
                      >
                      <i
                        class="el-icon-arrow-down el-icon--right c-black-text"
                      ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="item in list_policy"
                        :key="item.key"
                        :value="item.link"
                        :command="item.link"
                      >
                        <span>{{ item.label }}</span></el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </md-list-item>
                <md-list-item class="lang-pc">
                  <el-dropdown trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                      <flag :iso="locale || 'vn'" v-bind:squared="false" />
                      <span class="text-lang c-black-text fw-600">{{
                        locale || "vn"
                      }}</span>
                      <i
                        class="el-icon-arrow-down el-icon--right c-black-text"
                      ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="lang in languages"
                        :key="lang.title"
                        :value="lang.language"
                        :command="lang.language"
                      >
                        <flag :iso="lang.flag" v-bind:squared="false" />
                        <span class="text-lang-item">{{
                          lang.flag
                        }}</span></el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </md-list-item>
                <md-list-item class="lang-pc">
                  <el-dropdown
                    v-if="getInfo()"
                    trigger="click"
                    @command="handleCommandUser"
                  >
                    <span class="el-dropdown-link">
                      <div
                        v-if="getInfo()"
                        class="flex align-center"
                        style="height: 24px;"
                      >
                        <el-avatar
                          style="border: 1px solid #1B4684;"
                          class="flex-shrink-0"
                          :size="30"
                          :src="getInfo().avatar || images.DefaultAvatar"
                          @error="errorHandler"
                        >
                          <img :src="images.DefaultAvatar" />
                        </el-avatar>
                      </div>
                      <img v-else :src="icons.UserIcon" alt="" />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="info">
                        {{ $t("accountInfo") }}</el-dropdown-item
                      >
                      <el-dropdown-item
                        v-if="!getInfo()"
                        command="login"
                        divided
                      >
                        {{ $t("login") }}</el-dropdown-item
                      >
                      <el-dropdown-item
                        command="logout"
                        v-if="getInfo()"
                        divided
                      >
                        {{ $t("logout") }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                  <div v-else @click="handleLogin">
                    <p class="m-0 p-vid">
                      {{ $t("login") }}
                    </p>
                  </div>
                </md-list-item>
              </md-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import MobileMenu from "@/layout/MobileMenu";
import { getToken, getInfo } from "@/utils/auth.js";
import i18n from "@/plugins/i18n";
import LogoWBooking from "@/assets/img/svg/logo-wbooking.svg";
import LogoVNA from "@/assets/img/svg/logo-vna.svg";
import ArrowLeftIcon from "@/assets/img/svg/arrow-left-icon.svg";
import HomeIcon from "@/assets/img/svg/home-icon.svg";
import LightBulb from "@/assets/img/svg/light-bulb.svg";
import { getBackGround, setFlag, setLanguage } from "@/utils/wapAuth";
import NavBarMobile from "@/layout/WapV2/NavBarMobile";
import { SOURCE_BANK } from "@/constant/contant";
import UserIcon from "@/assets/img/iconV2/btn_user.svg";
import { LIST_POLICY, LIST_PROD_BANK } from "@/constant/contant";

export default {
  components: {
    MobileMenu,
    NavBarMobile
  },
  props: {
    objectData: {
      type: Object,
      default() {
        return {};
      }
    },
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    },
    logo: {
      default: require("@/assets/img/logo/W_Booking_white.png")
    }
  },
  data() {
    return {
      listCategory: [],
      bg: getBackGround(),
      extraNavClasses: "",
      admin: getToken(),
      headerImage: {
        paddingTop: "15px",
        backgroundSize: "100% 100%",
        backgroundColor: "transparent !important"
      },
      languages: [
        { flag: "vn", language: "vi", title: "Tiếng Việt" },
        { flag: "us", language: "en", title: "English" },
        { flag: "kr", language: "kr", title: "한국어" },
        { flag: "jp", language: "jp", title: "日本語" }
      ],
      list_policy: LIST_POLICY,
      listProd: LIST_PROD_BANK,
      locale: localStorage.getItem("flag"),
      images: {
        LogoWBooking,
        DefaultAvatar:
          "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
      },
      imageZise: {
        pc: "width: 250px;",
      },
      icons: {
        ArrowLeftIcon,
        HomeIcon,
        LightBulb,
        UserIcon
      }
    };
  },
  created() {
    const bank = getToken()?.bank_id;

    let bg = "";
    switch (bank) {
      // case SOURCE_BANK.VIETIN:
      //   bg = "#005790";
      //   break;
      // case SOURCE_BANK.SCB:
      //   bg = "#2984ca";
      //   break;
      case +SOURCE_BANK.BIDV:
        bg = "transparent";
        break;
      case +SOURCE_BANK.VNA:
        bg = this.bg.c_white_background;
        this.images.LogoWBooking = LogoVNA
        this.imageZise = {
          pc: "width: 165px;",
        }
        break;
      default:
        bg = this.bg.c_white_background;
        //bg = "#FFDC2A";
        break;
    }
    // console.log("this.objectData________", this.objectData);

    this.headerImage = {
      backgroundColor: this.objectData.bg_color
        ? this.objectData.bg_color + "!important"
        : `${bg} !important`,
      paddingTop: " 10px",
      backgroundSize: "100% 100%"
    };
  },
  computed: {
    showLogin() {
      return !getInfo();
    }
  },
  methods: {
    getToken,
    getInfo,
    errorHandler(event) {
      event.target.src = this.images.DefaultAvatar;
      return;
    },
    handleCommandUser(value) {
      console.log(value);
      switch (value) {
        case "info":
          if (!getInfo()) {
            this.handleLogin();
            return;
          }
          this.$store.dispatch("setShowProfile", true);

          break;
        case "login":
          this.handleLogin();
          break;
        case "logout":
          this.handleLogout();
          break;
        default:
          break;
      }
    },
    routePush(path) {
      return this.$router.push(path);
    },
    handleHistory() {
      if (!getInfo()) {
        this.handleLogin();
        return;
      }
      this.$router.push("/wap/history");
    },
    handleBack() {
      if (this.objectData.isDialog) {
        this.$store.dispatch("hideOtpDialog");
      } else {
        this.$router.go(this.objectData.routerGo || -1);
      }
    },
    handleResize() {
      // Xử lý khi chiều rộng màn hình thay đổi
      const windowWidth = window.innerWidth;
      if (windowWidth <= 991) {
        this.extraNavClasses = "";
      } else {
        this.extraNavClasses = `md-white`;
      }
    },
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);
        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    navigateHotDeals(val) {
      this.$router.push(`/wap/pax-by-category/${val.id}?title=${val.name}`);
    },

    handleLogin() {
      this.toggleNavbarMobile();
      this.$store.dispatch("showLoginDialog");
    },
    handleLogout() {
      this.toggleNavbarMobile();
      window.localStorage.clear("info");
      window.location.reload();
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      // this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    handleCommandPolicy(command) {
      window.open(command, "_blank");
    },
    handleCommandProd(menu) {
      this.$router.push({
        path: "/wap/redirect-other-service",
        query: {
          title: menu.label,
          type: menu.key
        }
      });
    },
    handleCommand(command) {
      i18n.locale = command;
      setLanguage(command);

      switch (command) {
        case "en":
          this.locale = "us";
          setFlag("us");

          break;
        case "vi":
          this.locale = "vn";
          setFlag("vn");

          break;
        case "kr":
          this.locale = "kr";
          setFlag("kr");

          break;
        case "jp":
          this.locale = "jp";
          setFlag("jp");

          break;
        default:
          this.locale = command;
          setFlag(command);

          break;
      }
    },
    handleScroll() {
      if (getToken()?.bank_id == SOURCE_BANK.BIDV) {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        let bg = "transparent !important";
        if (scrollTop >= 20) {
          bg = "#ffff !important";
        } else {
          bg = "transparent !important";
        }
        this.headerImage.backgroundColor = bg;
        this.$store.dispatch("setheaderPage", {
          backgroundColor: bg
        });
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleScroll);
    this.handleResize();
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>
<style></style>
<style scoped>
.p-vid {
  color: v-bind("bg.colorMain") !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 24px !important;
  text-align: center;
  text-transform: uppercase;
}
.mobile {
  display: none;
}
.pc {
  display: block;
}
.lang-mobile {
  background: v-bind("bg.colorMain") !important ;
  display: none;
}
.md-list-item .md-list-item-content p {
  color: v-bind("bg.c_menu_header");
}

.text-lang {
  color: v-bind("bg.colorMain") !important ;
  padding-left: 4px;
  text-transform: uppercase;
}
.text-lang-item {
  color: v-bind("bg.colorMain") !important ;

  padding-left: 4px;
  text-transform: uppercase;
}
.white-color {
  color: v-bind("bg.c_menu_header");
}
@media (max-width: 991px) {
  .md-collapse-lateral .md-collapse::before {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    display: none !important;
    content: "";
    z-index: 1;
  }
}
@media screen and (min-width: 0px) and (max-width: 992px) {
  .title {
    color: black;
    font-weight: 600;
    font-size: 16px;
  }

  .header-mobile {
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    height: 20px !important;
  }
  .md-collapse::before {
    position: fixed;
    display: none !important;
    top: 0;
    height: 100vh;
    width: 230px !important;
    right: 0;
    left: auto;
    z-index: 1032;
    visibility: visible;
    background-color: v-bind("bg.c_header") !important;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    padding-right: 0px;
    padding-left: 0;
  }
  .lang-mobile {
    background: #0000 !important ;
    display: block;
    padding-left: 25px;
  }
  .lang-pc {
    display: none;
  }
  .mobile {
    display: block;
  }
  .pc {
    display: none;
  }
}
</style>
